import React from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { hasEntries } from "../../../functions/array";
import DocumentFolderList from "./DocumentFolderList";

function DocumentExpansionPanel({
  primary = [],
  secondary = [],
  getSecondaryContent,
}) {
  const [expanded, setExpanded] = React.useState(0);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      {primary.map((category, index) => {
        const filteredData = secondary.filter(
          (data) => data.category?.id === category.id,
        );
        const secondaryContent = getSecondaryContent
          ? getSecondaryContent(filteredData)
          : filteredData;

        if (!hasEntries(secondaryContent)) return null;

        return (
          <Accordion
            key={category.id || index}
            disabled={category.disabled}
            expanded={expanded === category.id}
            onChange={handleChange(category.id)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">{category.name}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0 }}>
              <DocumentFolderList data={secondaryContent} />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}

export default DocumentExpansionPanel;
